export default __webpack_public_path__ + "static/media/price-calculator-pic-2.9d30aa43.png";